module.exports = __webpack_public_path__ + "./Ilin2_9fe625727bbf6e5972766e96d9a5fd12.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2022/Ilin2.png
// module id = 555
// module chunks = 0